export default __webpack_public_path__ + "static/media/onelastpush.dbfcebbb.png";